import Subscriptions from "./Subscriptions";

export default Subscriptions;
